import { useCallback } from "react";

import { useObjectMemo } from "../../../hooks";
import { useRequestWithFeedback } from "../../../composites";

export const useTileAuthorization = (tile: API.NarmiTile) => {
  const { send } = useRequestWithFeedback<API.GetAuthorization.Response>();

  const getAuthorization = useCallback(async () => {
    return new Promise<string | null>((resolve) => {
      send({
        action: {
          url: `apps/authorize?client_id=${tile.client_id}`,
          options: {
            method: "GET",
          },
        },
        onData: ({ authorization }) => {
          resolve(authorization.code);
        },
        onError: () => {
          resolve(null);
        },
      });
    });
  }, [send, tile.client_id]);

  return useObjectMemo({
    getAuthorization,
  });
};
